// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_OdK","cls2":"JJHomePageSearch-cls2_mEA JJHomePageSearch-cls1_OdK"};